module.exports = __webpack_public_path__ + "static/media/under_capacity.2e0ab81b.svg";